import { createRouter, createWebHistory  } from 'vue-router'
import store from '../store/index.js'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('../components/common/Home.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../components/common/PrivacyPolicy.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import('../components/common/TermsOfService.vue')
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: () => import('../components/common/AboutUs.vue')
  },
  {
    path: '/',
    name: 'login',
    component: () => import('../components/auth/Login.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../components/auth/Logout.vue')
  },
  {
    path: '/purchase/order',
    name: 'Purchase Order',
    component: () => import('../components/purchase/order/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/purchase/invoice',
    name: 'Purchase Invoice',
    component: () => import('../components/purchase/invoice/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/purchase/return',
    name: 'Purchase Return',
    component: () => import('../components/purchase/purchaseReturn/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stock/in',
    name: 'Stock In',
    component: () => import('../components/inventory/stockIn/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stock/out',
    name: 'Stock Out',
    component: () => import('../components/inventory/stockOut/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stock/adjustment',
    name: 'Stock Adjustment',
    component: () => import('../components/inventory/stockAdjustment/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sales/invoice',
    name: 'Sales Invoice',
    component: () => import('../components/sales/invoice/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/proforma/invoice',
    name: 'Proforma Invoice',
    component: () => import('../components/sales/proformaInvoice/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sales/return',
    name: 'Sales Return',
    component: () => import('../components/sales/salesReturn/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sales/order',
    name: 'Sales Order',
    component: () => import('../components/sales/order/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/quotation',
    name: 'Quotation',
    component: () => import('../components/sales/quotation/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('../components/sales/events/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/delivery/challan',
    name: 'Delivery Challan',
    component: () => import('../components/sales/deliveryChallan/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/items/category',
    name: 'Items Category',
    component: () => import('../components/items/Category.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('../components/common/Company.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/branches',
    name: 'Branch',
    component: () => import('../components/common/Branch.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouses',
    name: 'Warehouse',
    component: () => import('../components/warehouse/Warehouse.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/company/setup',
    name: 'Company Setup',
    component: () => import('../components/common/CompanySetup.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/menu',
    name: 'Menu',
    component: () => import('../components/common/Menu.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gst/data',
    name: 'GST Data',
    component: () => import('../components/common/GSTData.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/category/type',
    name: 'Account Category Type',
    component: () => import('../components/accounts/CategoryType.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/category',
    name: 'Account Category',
    component: () => import('../components/accounts/Category.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/voucher/type',
    name: 'Voucher Type',
    component: () => import('../components/accounts/VoucherType.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/account/head',
    name: 'Account Head',
    component: () => import('../components/accounts/AccountHead.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/group',
    name: 'Account Group',
    component: () => import('../components/accounts/Group.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts',
    name: 'Account',
    component: () => import('../components/accounts/Account.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/regions/state',
    name: 'State',
    component: () => import('../components/regions/State.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/regions/city',
    name: 'City',
    component: () => import('../components/regions/City.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/regions/locality',
    name: 'Locality',
    component: () => import('../components/regions/Locality.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/items/brand',
    name: 'Items Brand',
    component: () => import('../components/items/Brand.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/items/color',
    name: 'Items Color',
    component: () => import('../components/items/Color.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/items/uom',
    name: 'UOM',
    component: () => import('../components/items/UOM.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/items',
    name: 'Items',
    component: () => import('../components/items/Item.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/shipping/method',
    name: 'ShippingMethod',
    component: () => import('../components/sales/ShippingMethod.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/discounts',
    name: 'Discount',
    component: () => import('../components/discount/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/discounts/slab',
    name: 'Discount Slabs',
    component: () => import('../components/discount/slab/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/taxation/slab',
    name: 'Taxation Slabs',
    component: () => import('../components/taxation/slab/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/customers',
    name: 'Customer',
    component: () => import('../components/accounts/Customer.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vendors',
    name: 'Vendor',
    component: () => import('../components/accounts/Vendor.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/banks',
    name: 'Bank',
    component: () => import('../components/accounts/Bank.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/voucher',
    name: 'Voucher',
    component: () => import('../components/accounts/voucher/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/user',
    name: 'User',
    component: () => import('../components/admin/User.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/permission',
    name: 'Permission',
    component: () => import('../components/admin/Permission.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/permission/types',
    name: 'PermissionType',
    component: () => import('../components/admin/Permission.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'User Setting',
    component: () => import('../components/common/Settings.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user',
    name: 'User Info',
    component: () => import('../components/common/User.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../components/auth/Signup.vue')
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('../components/auth/Signup.vue')
  },
  {
    path: '/reports/stock/ledger',
    name: 'stockLedger',
    component: () => import('../components/reports/stock/Ledger.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/account/ledger',
    name: 'accountLedger',
    component: () => import('../components/reports/account/Ledger.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/purchase/requirement',
    name: 'purchaserequirement',
    component: () => import('../components/reports/purchase/Requirement.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/items',
    name: 'Jaquar DMS - Sync Items',
    component: () => import('../components/jaquarDMS/syncItems/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/sales/order',
    name: 'Jaquar DMS - Sync Sales Order',
    component: () => import('../components/jaquarDMS/syncSalesOrder/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/purchase/order',
    name: 'Jaquar DMS - Sync Purchase Order',
    component: () => import('../components/jaquarDMS/syncPurchaseOrder/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/purchase/invoice',
    name: 'Jaquar DMS - Sync Purchase Invoice',
    component: () => import('../components/jaquarDMS/syncPurchaseInvoice/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/sales/return',
    name: 'Jaquar DMS - Sync Sales Return',
    component: () => import('../components/jaquarDMS/syncSalesReturn/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/sales/invoice',
    name: 'Jaquar DMS - Sync Sales Invoice',
    component: () => import('../components/jaquarDMS/syncSalesInvoice/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/material/adjustment',
    name: 'Jaquar DMS - Material Adjustment',
    component: () => import('../components/jaquarDMS/materialAdjustment/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/sync/issue/challan',
    name: 'Jaquar DMS - Sync Issue Challan',
    component: () => import('../components/jaquarDMS/syncIssueChallan/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jaquar/dms/warehouse/items',
    name: 'Jaquar DMS - Warehouse Items',
    component: () => import('../components/jaquarDMS/warehouseItems/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // Warehouse Management System Routes
  {
    path: '/warehouse/items',
    name: 'Warehouse Items',
    component: () => import('../components/warehouse/WarehouseItem.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/locations',
    name: 'Warehouse Locations',
    component: () => import('../components/warehouse/WarehouseLocation.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/warehouse/stock-type',
    name: 'Stock Types',
    component: () => import('../components/warehouse/StockType.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/warehouse/adjustment',
    name: 'Warehouse Adjustment',
    component: () => import('../components/warehouse/adjustment/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/zones',
    name: 'Warehouse Zones',
    component: () => import('../components/warehouse/WarehouseZone.vue'),
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path: '/warehouse/location-types',
    name: 'Location Types',
    component: () => import('../components/warehouse/LocationType.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/location-status',
    name: 'Location Status',
    component: () => import('../components/warehouse/LocationStatus.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/document-types',
    name: 'Document Types',
    component: () => import('../components/warehouse/WarehouseDocumentType.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/custom-fields',
    name: 'Custom Fields',
    component: () => import('../components/warehouse/WarehouseCustomField.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/putaway',
    name: 'PutAway',
    component: () => import('../components/warehouse/putaway/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/pick',
    name: 'Pick',
    component: () => import('../components/warehouse/pick/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/transfer',
    name: 'WarehouseTransfer',
    component: () => import('../components/warehouse/transfer/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/dashboard',
    name: 'Warehouse Dashboard',
    component: () => import('../components/warehouse/dashboard/WarehouseDashboard.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // Warehouse Reports (individual routes with specific permissions)
  {
    path: '/warehouse/reports/bin-status',
    name: 'Warehouse Bin Status Report',
    component: () => import('../components/warehouse/reports/WarehouseBinStatusReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/reports/putaway',
    name: 'Warehouse PutAway Report',
    component: () => import('../components/warehouse/reports/WarehousePutAwayReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/reports/pick',
    name: 'Warehouse Pick Report',
    component: () => import('../components/warehouse/reports/WarehousePickReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/reports/transfer',
    name: 'Warehouse Transfer Report',
    component: () => import('../components/warehouse/reports/WarehouseTransferReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/reports/adjustment',
    name: 'Warehouse Adjustment Report',
    component: () => import('../components/warehouse/reports/WarehouseAdjustmentReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // New Missing Warehouse Reports
  {
    path: '/reports/warehouse/pendingputaway',
    name: 'Warehouse Pending PutAway Report',
    component: () => import('../components/warehouse/reports/WarehousePendingPutAwayReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/warehouse/shortpick',
    name: 'Warehouse Short Pick Report',
    component: () => import('../components/warehouse/reports/WarehouseShortPickReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/warehouse/qualityinspection',
    name: 'Warehouse Quality Inspection Report',
    component: () => import('../components/warehouse/reports/WarehouseQualityInspectionReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/warehouse/reports/stock-variance',
    name: 'Warehouse Stock Variance Report',
    component: () => import('../components/warehouse/reports/WarehouseStockVarianceReport.vue'),
    meta: {
      requiresAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router
